// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'my stories',
    path: '/dashboard/stories',
    icon: getIcon('eva:book-open-fill')
  },
  {
    title: 'learn',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill')
  },
  {
    title: 'community',
    path: '/dashboard/user',
    icon: getIcon('eva:people-fill')
  },
  {
    title: 'challenges',
    path: '/dashboard/products',
    icon: getIcon('eva:shopping-cart-fill')
  },
  {
    title: 'articles',
    path: '/dashboard/blog',
    icon: getIcon('eva:file-text-fill')
  }
];

export default sidebarConfig;
